import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';

import { FeatureListStrapiProps } from '@/features/shared/FeatureListStrapi';
import { Product } from '@/features/types/product';

import { BlockComponentModel } from '@/components/cms/types/blok-component';
import {
  BlockHeader,
  BlockHeaderContent,
} from '@/features/utils/BlockHeaderContentDC';
import { BlockWrapper } from '@/features/utils/BlockWrapperDC';
import PricingTable, { PricingRowsProps } from './PricingTable';

export type PricingCardsFeatureListStrapiProps = Array<
  FeatureListStrapiProps & {
    title?: string;
    productType: Product;
  }
>;

type PricingCardsStrapiProps = {
  header?: BlockHeader;
  pricing_cards: {
    data: {
      id: string;
      attributes: PricingRowsProps['cards'][number];
    }[];
  };
};

export function PricingTableStrapi({
  block,
  ...rest
}: BlockComponentModel<PricingCardsStrapiProps>) {
  const { header, pricing_cards } = block;

  const formattedCards = pricing_cards.data.map(({ attributes: card }) => card);

  return (
    <BlockWrapper {...rest} data-tracker-section={SECTION_NAMES.PRICING_TABLE}>
      <div>
        <BlockHeaderContent {...header}>
          <PricingTable cards={formattedCards} />
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
